var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"98%","margin":"0 auto"}},[_c('iframe',{staticStyle:{"width":"100%","height":"800px"},attrs:{"src":_vm.getUrl}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06665da2","hasScoped":false,"transformToRequire":{"audio":"src","video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/race-dialog.vue
// module id = null
// module chunks = 